module.exports = __webpack_public_path__ + "img/85.cd0aa8e7.jpg";